import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import Box from "@mui/material/Box";
import axios from "axios";
import "./../style.css";
import calendarpng from "./../Asset/New_Assert/ESO_Icon/Filter.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Select from "react-select";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { Card, Tooltip } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import RunReportNow from "./../RunReportNow";
import { Domain, Language, TravelExplore } from "@mui/icons-material";
import { ToastContainer, toast } from "react-toastify";
import Sidebar from "./../Rightsidebar/Rightsidebar";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Rightsidebar from "./../Rightsidebar/Rightsidebar";
import { useNavigate } from "react-router-dom";
import { Commonfun, removeDuplicateDate } from "./../Commonfun";
import { AppContext } from "../../../Context/Context";
import { timezonechange } from "./../Commonfun";
import { timezoneval } from "./../Commonfun";
import { datezonechange } from "./../Commonfun";
import { Utils } from "../../../Utils/Utils";
import Freeaudit from "../../../Utils/Freeaudit";
import Loader from "./../CommonLoader";
import CommonAlert from "../../../Commonalert/commonalert";
import { customDropdownStyles } from "../../../Commonalert/commonDropdown";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { Breadcrumbs, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import DatagridComp from "./../DatagridComp";
import PdfandCsv from "./../PdfandCsv";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import UserActivityTracker from "../../../hooks/userActivityTracker";
import Chart from "react-apexcharts";
import Commoncard from "./../Commoncard";
import VisibilityScoreIcon from "./../Asset/esocardicon/RankingSummary/Visibility_Score.svg";
import TotalCitationsIcon from "./../Asset/esocardicon/RankingSummary/Total_keywords.svg";
import TotalMentionsIcon from "./../Asset/esocardicon/RankingSummary/Ranked_Keywords.svg";
import TotalPromptsIcon from "./../Asset/esocardicon/RankingSummary/First_Page_Ranked_keywords.svg";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ScoreGauge from "../../../Components/chart/gaugeChart";

// ── Markdown helpers (defined outside component to avoid re-creation) ──────────
function inlinemd(s) {
  return s
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(
      /\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g,
      '<a href="$2" target="_blank" rel="noopener noreferrer" style="color:#d85a30;text-decoration:none">$1</a>'
    )
    .replace(
      /(?<![">])(https?:\/\/\S+)/g,
      '<a href="$1" target="_blank" rel="noopener noreferrer" style="color:#d85a30;text-decoration:none">$1</a>'
    );
}

function mdToHtml(raw) {
  if (!raw) return "";
  const lines = raw.split("\n");
  let html = "";
  let inUl = false;

  for (const line of lines) {
    const li = line.match(/^\*\s+(.+)/);
    if (li) {
      if (!inUl) {
        html += "<ul style='margin:4px 0 4px 16px;padding:0'>";
        inUl = true;
      }
      html += `<li style='margin-bottom:3px'>${inlinemd(li[1])}</li>`;
    } else {
      if (inUl) {
        html += "</ul>";
        inUl = false;
      }
      const t = line.trim();
      if (t === "") {
        html += "<br/>";
      } else {
        html += `<p style='margin:0 0 4px'>${inlinemd(t)}</p>`;
      }
    }
  }
  if (inUl) html += "</ul>";
  return html;
}
// ─────────────────────────────────────────────────────────────────────────────

export default function BrandmentioncitationReport() {

  const isMobile = useMediaQuery({ maxWidth: 600 });
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [cardData, setCardData] = useState([]);
  const [summaryData, setSummaryData] = useState(null);
  const [jobidData, setjobidData] = useState("");
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(new Date());
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [open, setOpen] = React.useState(false);
  const [jobDate, setjobDate] = useState("");
  const [completedate, setcompletedate] = useState([]);
  const [selectval, setSelectval] = useState("");
  const [SectionOptions, SetSectionOptions] = useState([]);
  const [DoaminSectionUrl, SetDoaminSectionUrl] = useState([]);
  const [Domainsectiondata, SetDomainsectiondata] = useState([]);
  const [initialDateval, SetInitialDateval] = useState([]);
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [autoheightval, SetAutoheightval] = useState(true);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [errors, setErrors] = useState({});
  const [analysisSummaryPlan, setanalysisSummaryPlan] = useState({
    status: false,
    error: "",
  });
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [first, setfirst] = useState({
    name: "",
    path: "",
    closeName: "Close",
    statusDomain: false,
  });
  const [checkD, setcheckD] = useState(false);
  const [domainNameUrl, setDomainNameUrl] = useState({
    domain_name: "",
    domain_url: "",
  });
  const [dEngineoption, SetdEngineoption] = useState({
    label: "Select Date",
    value: "Select Date",
  });
  const [prevdEngineoption, setprevdEngineoption] = useState({
    label: "Select Date",
    value: "Select Date",
  });
  const [faqData, setfaqData] = useState("2");
  const [datagridval, setDatagridval] = useState(1);
  const navigate = useNavigate();
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const handleClose = () => {
    setOpen(false);
  };
  const apihandleClose = () => {
    setapiOpen(false);
  };

  const [chartData, setChartData] = useState();
  const [kpicardData, setKpiCardData] = useState();
  const [citedUrlModalOpen, setCitedUrlModalOpen] = useState(false);
  const [selectedCitedUrls, setSelectedCitedUrls] = useState([]);
  const [validation, setValidation] = useState({
    dateerror: "",
  });
  let detailurl = `${process.env.REACT_APP_DOMAIN}content-detail/`;
  const [aimodel, setAimodel] = useState("");
  const [citedurl, setCitedurl] = useState("");
  const [sentiment, setSentiment] = useState("");
  const [citationFormOpen, setCitationFormOpen] = useState(false);
  const [citationUrl, setCitationUrl] = useState("");
  const [citationQuery, setCitationQuery] = useState("");
  const [citationErrors, setCitationErrors] = useState({ url: "", query: "" });

  const arr = [];

  useEffect(() => {
    tableData();
    CharacterData();
    CardKpiData();
    faqdatafun();
  }, []);

  const tableData = async () => {
    try {
      const datavalue = await axios
        .get(
          `${process.env.REACT_APP_API_URL}technical/ai_mention_summary_table/?user_domain_id=${esodata.domaindata.value.header_selected}&ai_model=${aimodel}&sentiment=${sentiment}`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          },
        )
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 400 ||
            error?.response?.status == 500
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (
            error?.code == "ERR_NETWORK" ||
            error?.response?.status == 404
          ) {
            navigate("/errorpages");
          }
        });

      const dataval = datavalue?.data?.result;

      if (dataval && dataval.length > 0) {
        const newData = dataval.map((obj, index) => {
          return { ...obj, sid: index + 1 };
        });
        setjobidData(datavalue?.data?.job_id);
        SetAutoheightval(false);
        setCardData(newData);
        setTableLoading(false);
      } else {
        SetAutoheightval(true);
        setCardData("");
        setjobDate();
        setTableLoading(false);
      }
    } catch (err) {
      setCardData("");
      if (err.code == "ERR_NETWORK") {
        navigate("/*");
      }
    }
  };

  const CardKpiData = async (jobID = "") => {
    try {
      const cardData = await axios.get(
        `${process.env.REACT_APP_API_URL}technical/ai_mention_dashboard_kpi/?user_domain_id=${esodata.domaindata.value.header_selected}${jobID ? `&job_id=${jobID}` : ""}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      );
      setKpiCardData(cardData?.data);
    } catch (err) { }
  };

  const CharacterData = async (jobID = "") => {
    try {
      const charData = await axios.get(
        `${process.env.REACT_APP_API_URL}technical/ai_mention_dashboard_charts/?user_domain_id=${esodata.domaindata.value.header_selected}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      );
      setChartData(charData?.data);
    } catch (err) { }
  };

  const Columns = [
    {
      field: "query",
      headerName: "Query",
      description: "The question tested in AI tools",
      minWidth: 250,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
    },
    {
      field: "ai_model",
      headerName: "AI Model",
      minWidth: 160,
      flex: 0.9,
      sortable: true,
      headerAlign: "center",
      align: "center",
      description: "The AI platform that generated the response.",
      renderCell: (params) => {
        const value = params.value;
        return value ? String(value) : "-";
      },
    },
    {
      field: "mention_count",
      headerName: "Mention Count",
      description: "Number of times your brand name appeared in the response.",
      minWidth: 125,
      flex: 1,
      headerAlign: "center",
      align: "center",
      type: "number",
    },
    {
      field: "sentiment",
      headerName: "Sentiment",
      minWidth: 150,
      flex: 0.8,
      sortable: true,
      headerAlign: "center",
      align: "center",
      description: "Shows whether your website link appeared in the AI response.",
    },
    {
      field: "sentiment_score",
      headerName: "Sentiment Score",
      minWidth: 150,
      flex: 0.8,
      sortable: true,
      headerAlign: "center",
      align: "center",
      description: "Shows whether your website link appeared in the AI response.",
    },
    {
      field: "created_at",
      headerName: "First Mentioned",
      minWidth: 180,
      flex: 1,
      sortable: true,
      headerAlign: "center",
      align: "center",
      description: "The date and time when this result was generated.",
      renderCell: (params) => {
        const value = params.value;
        if (value) {
          const date = new Date(value);
          return date.toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
        }
        return "-";
      },
    },
    {
      field: "cited_url",
      headerName: "Action",
      minWidth: 180,
      flex: 1,
      sortable: false,
      headerAlign: "center",
      align: "center",
      description: "The mention context from the AI provider response",
      renderCell: (cardData) => {
        const value = cardData?.row?.mention_context;
        if (Array.isArray(value) && value.length > 0) {
          return (
            <button
              onClick={() => {
                setSelectedCitedUrls(value);
                setCitedUrlModalOpen(true);
              }}
              style={{
                backgroundColor: "#ff601f",
                color: "white",
                border: "none",
                padding: "6px 12px",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "11px",
                fontWeight: "600",
              }}
            >
              View ({value.length})
            </button>
          );
        }
        return "-";
      },
    },
  ];

  const rows = cardData ?? [];

  const callUserdataApi = async (jobid = "", domainsecdata = "") => {
    setLoading(true);
    setTableLoading(true);
    if (jobid == "") jobid = jobidData;
    try {
      const datavalue = await axios
        .get(
          `${process.env.REACT_APP_API_URL}content/v2/analysis_summary/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobid}&domain_section_id=${domainsecdata}`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          },
        )
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 400 ||
            error?.response?.status == 500
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (
            error?.code == "ERR_NETWORK" ||
            error?.response?.status == 404
          ) {
            navigate("/errorpages");
          }
        });
      if (jobidData == "") {
        const completevalues = await axios
          .get(
            `${process.env.REACT_APP_API_URL}domain/get_report_job_details/?job_type=analysis_summary&user_domain_id=${esodata.domaindata.value.header_selected}&domain_section_id=${esodata.sectiondomaindata.value}`,
            {
              headers: {
                Authorization: `${ApiToken}`,
              },
            },
          )
          .catch((error) => {
            if (
              error?.response?.status == 599 ||
              error?.response?.status == 400 ||
              error?.response?.status == 500
            ) {
              setapiOpen(true);
              setapierrorMsg(error?.response?.data?.error);
            } else if (
              error?.code == "ERR_NETWORK" ||
              error?.response?.status == 404
            ) {
              navigate("/errorpages");
            }
          });
        const uniqueByCompletedAt = removeDuplicateDate(completevalues?.data?.jobs);
        SetInitialDateval(uniqueByCompletedAt[0]);
        setSelectval(uniqueByCompletedAt[0]);
        SetdEngineoption(uniqueByCompletedAt[0]);
        setprevdEngineoption(uniqueByCompletedAt[0]);
        setcompletedate(uniqueByCompletedAt);
      }
      const dataval = datavalue?.data?.table_data;

      if (datavalue?.data) {
        setSummaryData({
          total_vital_score: datavalue.data.total_vital_score,
          read_ease_chart: datavalue.data.read_ease_chart,
          grade_level_distribution: datavalue.data.grade_level_distribution,
          top_5_urls: datavalue.data.top_5_urls,
          low_5_urls: datavalue.data.low_5_urls,
          weekly_trend: datavalue.data.weekly_trend,
        });
      }

      if (datavalue?.data?.job_date)
        setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"));
      else setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY"));

      if (dataval && dataval.length > 0) {
        const newData = dataval.map((obj, index) => {
          return { ...obj, sid: index + 1 };
        });
        setjobidData(datavalue?.data?.job_id);
        SetAutoheightval(false);
        setCardData(newData);
        setTableLoading(false);
      } else {
        SetAutoheightval(true);
        setCardData("");
        setjobDate();
        setTableLoading(false);
      }
    } catch (err) {
      setCardData("");
      if (err.code == "ERR_NETWORK") {
        navigate("/*");
      }
    }
    setLoading(false);
  };

  const reportNow = async () => {
    var errs = 1;
    let errors = {};
    if (!selectval || !selectval.value) {
      errors.dateerror = "This field is required.";
      errs = 2;
    } else {
      errs = 1;
      setValidation(errors);
    }
    if (errs === 2) {
      return setValidation(errors);
    }
    setLoading(true);
    setjobidData(selectval.value);
    setIsOpen(false);
    setprevdEngineoption(dEngineoption);
    var domainsec = "";
    callUserdataApi(selectval.value, (domainsec = ""));
    CharacterData(selectval.value);
    CardKpiData(selectval.value);
  };

  function openModal() {
    setfaqData(2);
    setToggle(false);
    setIsOpen(true);
  }
  function closeModal() {
    setSelectval("");
    setIsOpen(false);
    SetdEngineoption(prevdEngineoption);
  }

  const pdfdown = async () => {
    setLoading(true);
    setIsDownloading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}technical/ai_mention_summary_table/?user_domain_id=${esodata.domaindata.value.header_selected}&ai_model=${aimodel}&sentiment=${sentiment}&formats=pdf&timezone=${timezoneval()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/pdf",
            Authorization: `${ApiToken}`,
          },
        },
      );
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun(
          "Ai Citation - Brand Mention Report",
          "pdf",
          ApiToken,
          esodata.domaindata.value.header_selected,
        );
        link.download = filedata;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } else {
        if (
          response?.status == 599 ||
          response?.status == 500 ||
          response?.status == 400 ||
          response?.status == 404 ||
          response?.status == 502
        ) {
          response.json().then((data) => {
            setapiOpen(true);
            setapierrorMsg(data?.error);
          });
        } else if (response?.code == "ERR_NETWORK") {
          navigate("/errorpages");
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error("Error during PDF download:", error);
    }
    setLoading(false);
    setIsDownloading(false);
  };

  const csvdown = async () => {
    setLoading(true);
    setIsDownloadingcsv(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}technical/ai_mention_summary_table/?user_domain_id=${esodata.domaindata.value.header_selected}&ai_model=${aimodel}&sentiment=${sentiment}&formats=csv&timezone=${timezoneval()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/csv",
            Authorization: `${ApiToken}`,
          },
        },
      );
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun(
          "Ai Citation Brandmention Report",
          "csv",
          ApiToken,
          esodata.domaindata.value.header_selected,
        );
        link.download = filedata;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } else {
        if (
          response?.status == 599 ||
          response?.status == 500 ||
          response?.status == 400 ||
          response?.status == 404 ||
          response?.status == 502
        ) {
          response.json().then((data) => {
            setapiOpen(true);
            setapierrorMsg(data?.error);
          });
        } else if (response?.code == "ERR_NETWORK") {
          navigate("/errorpages");
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error("Error during PDF download:", error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);
  };

  const [RunReportPopShow, SetRunReportPopShow] = useState(false);
  const [RunReportType, SetRunReportType] = useState("analysis_summary");
  const [toggle, setToggle] = useState(false);
  const wrapperRef = useRef(null);

  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=95`;
    try {
      const doaminsectiondatavalue = await axios
        .get(datavar, {
          headers: {
            Authorization: `${ApiToken}`,
          },
        })
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 400 ||
            error?.response?.status == 500
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (
            error?.code == "ERR_NETWORK" ||
            error?.response?.status == 404
          ) {
            navigate("/errorpages");
          }
        });
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs);
      }
    } catch (err) { }
  };

  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1);
    } else {
      setfaqData(2);
    }
    setToggle((pre) => !pre);
  };

  function handleReset() {
    SetdEngineoption("");
    setSelectval("");
  }

  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleModelPopUp = () => {
    openModal();
  };
  const handleDownlodingCSV = () => {
    csvdown();
  };
  const handleDownlodingPDF = () => {
    pdfdown();
  };

  const gaugeChart = () => {
    return (
      <div>
        <ScoreGauge score={kpicardData?.ai_visibility_score} />
      </div>
    );
  };

  // ── Color helpers ────────────────────────────────────────────────
  const providerColorMap = {
    openai: "#10a37f",
    claude: "#d97757",
    perplexity: "#c9d429",
    gemini: "#4285f4",
    copilot: "#ae36ee",
  };

  const sentimentColorMap = {
    positive: "#00C9A7",
    negative: "#FF4D4F",
    neutral: "#faad14",
    mixed: "#3f51b5",
  };

  // ── Close mention context modal ──────────────────────────────────
  const handleCloseMentionModal = () => {
    setCitedUrlModalOpen(false);
    setSelectedCitedUrls([]);
  };

  return (
    <div
      className={`over_all_container over_all_accessibility ${isMenuExpanded ? "blur overflow-hidden" : ""}`}
    >
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Ai Citation - Brand Mention Report</title>
      </Helmet>
      <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
      {loading === true ? <Loader /> : null}

      {/* ── Header ─────────────────────────────────────────────────── */}
      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>
              <div>
                <h1 className="dashboard_header">
                  Ai Citation - Brand Mention Report
                  <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Ai Citation - Brand Mention Report', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {/* ── Run Report Button ───────────────────────────────────────── */}
      {/* <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6} />
            <Grid item xs={12} md={6}>
              <div className="drop_down_button">
                <button
                  title="Run Report"
                  className="btn_dashboard"
                  onClick={() => {
                    if (first.statusDomain) {
                      setcheckD(first.statusDomain);
                    } else {
                      setfaqData(2);
                      setToggle(false);
                      setCitationFormOpen(true);
                    }
                  }}
                >
                  Check Your Ai Citation Report
                </button>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container> */}

      {/* ── KPI Cards ──────────────────────────────────────────────── */}
      <Container maxWidth={false} className="dashboard-container">
        <Grid container spacing={2} style={{ marginBottom: '20px' }}>
          {/* Total Mentions */}
          <Grid item xs={12} sm={6} md={3}>
            <Commoncard
              item={{
                title: "Total Mentions",
                value: kpicardData?.total_mentions || 0,
                iconSrc: TotalCitationsIcon,
                iconColor: 2,
                bgColor: 2,
              }}
              nonclikable={true}
            />
          </Grid>
          {/* Positive Mentions */}
          <Grid item xs={12} sm={6} md={3}>
            <Commoncard
              item={{
                title: "Positive Mentions",
                value: kpicardData?.positive_mentions || 0,
                iconSrc: TotalMentionsIcon,
                iconColor: 3,
                bgColor: 3,
              }}
              nonclikable={true}
            />
          </Grid>
          {/* Negative Mentions */}
          <Grid item xs={12} sm={6} md={3}>
            <Commoncard
              item={{
                title: "Negative Mentions",
                value: kpicardData?.negative_mentions || 0,
                iconSrc: VisibilityScoreIcon,
                iconColor: 4,
                bgColor: 4,
              }}
              nonclikable={true}
            />
          </Grid>
          {/* Neutral Mentions */}
          <Grid item xs={12} sm={6} md={3}>
            <Commoncard
              item={{
                title: "Neutral Mentions",
                value: kpicardData?.neutral_mentions || 0,
                iconSrc: TotalPromptsIcon,
                iconColor: 1,
                bgColor: 1,
              }}
              nonclikable={true}
            />
          </Grid>
          {/* Average Sentiment Score */}
          <Grid item xs={12} sm={6} md={3}>
            <Commoncard
              item={{
                title: "Average Sentiment Score",
                value: kpicardData?.avg_sentiment_score || 0,
                iconSrc: VisibilityScoreIcon,
                iconColor: 0,
                bgColor: 0,
              }}
              nonclikable={true}
            />
          </Grid>
        </Grid>
      </Container>

      {/* ── Charts ─────────────────────────────────────────────────── */}
      <Container maxWidth={false} className="dashboard-container">
        <Grid container spacing={2} style={{ marginBottom: '20px' }}>

          {/* 1. Weekly Mention Trend (area) */}
          <Grid item xs={12} md={4}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                Weekly Score Trend
              </Typography>
              <Chart
                type="area"
                height={220}
                series={[
                  {
                    name: "Mentions",
                    data: (chartData?.trend || []).map(i => i?.mentions || 0),
                  },
                ]}
                options={{
                  chart: { toolbar: { show: false } },
                  colors: ["#ff601f"],
                  stroke: { curve: 'smooth', width: 3 },
                  fill: {
                    type: 'gradient',
                    gradient: { shadeIntensity: 1, opacityFrom: 0.4, opacityTo: 0.1 },
                  },
                  xaxis: {
                    categories: (chartData?.trend || []).map(i =>
                      new Date(i?.date).toLocaleDateString('en-IN', { month: 'short', day: 'numeric' })
                    ),
                    labels: { style: { fontSize: '11px' } },
                  },
                  yaxis: { min: 0 },
                  grid: { padding: { left: 0, right: 0 } },
                  noData: { text: "No Trend Data Available" },
                }}
              />
            </Box>
          </Grid>

          {/* 2. Sentiment Distribution (donut) */}
          <Grid item xs={12} md={4}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                Sentiment Distribution
              </Typography>
              <Chart
                type="donut"
                height={240}
                series={(chartData?.sentiment_chart || []).map(i => Number(i?.count || 0))}
                options={{
                  labels: ["positive", "negative"],
                  colors: (chartData?.sentiment_chart || []).map(i =>
                    sentimentColorMap[(i?.sentiment || "").toLowerCase()] || '#ff601f'
                  ),
                  legend: { position: 'bottom', fontSize: '10px' },
                  dataLabels: { enabled: false },
                  noData: { text: "No Sentiment Data Available" },
                }}
              />
            </Box>
          </Grid>

          {/* 3. AI Provider Distribution (donut) */}
          <Grid item xs={12} md={4}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                AI Provider Distribution
              </Typography>
              <Chart
                type="donut"
                height={240}
                series={(chartData?.model_chart || []).map(i => Number(i?.count || 0))}
                options={{
                  labels: (chartData?.model_chart || []).map(i => i?.model || ""),
                  colors: (chartData?.model_chart || []).map(i =>
                    providerColorMap[(i?.model || "").toLowerCase()] || '#ff601f'
                  ),
                  legend: { position: 'bottom', fontSize: '10px' },
                  dataLabels: { enabled: false },
                  noData: { text: "No Provider Data Available" },
                }}
              />
            </Box>
          </Grid>

        </Grid>
      </Container>

      {/* ── Data Table ─────────────────────────────────────────────── */}
      <Container maxWidth={false} className="dashboard-container table-search-break">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap table-100-height">
                <DatagridComp
                  className="datagrid_custom_scroll"
                  columns={Columns}
                  rows={rows}
                  autoheightval={autoheightval}
                  datagridval={2}
                  tableLoading={tableLoading}
                  handleModelPopUp={handleModelPopUp}
                  handleDownlodingCSV={handleDownlodingCSV}
                  handleDownlodingPDF={handleDownlodingPDF}
                  customFilter={true}
                  DownloadShowFile={true}
                  DownloadShowPDF={1}
                  DownloadShowCSV={2}
                />
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {/* ── Footer ─────────────────────────────────────────────────── */}
      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2026 |
                  <a href="https://www.egrovesys.com/" target="blank">
                    <span className="footer-brand"> Elite site Optimizer</span>
                  </a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
                <p></p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {/* ── Sidebars / Dialogs ─────────────────────────────────────── */}
      <div className="">
        <div className="">
          {toggle && (
            <Rightsidebar
              close={() => setToggle(false)}
              setToggle={setToggle}
              initialfaqDateval={initialfaqDateval}
            />
          )}
        </div>

        {!openCommonAlerts && (
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle className="keyword-dialog-header">{"Error Message "}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                No Data Found
              </DialogContentText>
            </DialogContent>
            <DialogActions className="dialog-action-button">
              <Button onClick={handleClose}>Close</Button>
            </DialogActions>
          </Dialog>
        )}

        {!openCommonAlerts && (
          <CommonErrorAlert
            data={{
              apiopen: apiopen,
              apiErrorMsg: apierrorMsg,
              isIconStyled: true,
            }}
            closeAlert={apihandleClose}
          />
        )}

        <Dialog
          open={checkD}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="domain-verify-alert"
        >
          <DialogTitle className="keyword-dialog-header">Alert</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "15px",
                  lineHeight: "1px",
                  width: "max-content",
                }}
              >
                <p>{`Please verify your domain ${domainNameUrl.domain_name} to access these features`}</p>
                <a href={domainNameUrl.domain_url}>{domainNameUrl.domain_url}</a>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="dialog-action-button">
            <Button onClick={() => { navigate(first.path); }}>{first.name}</Button>
            <Button onClick={() => setcheckD(false)}>{first.closeName}</Button>
          </DialogActions>
        </Dialog>
      </div>

      <RunReportNow
        RunReportPopShow={RunReportPopShow}
        SetRunReportPopShow={SetRunReportPopShow}
        RunReportType={RunReportType}
        isDomainSection={true}
      />

      {/* ── Citation Form Dialog ────────────────────────────────────── */}
      <Dialog
        open={citationFormOpen}
        onClose={() => {
          setCitationFormOpen(false);
          setCitationUrl("");
          setCitationQuery("");
          setCitationErrors({ url: "", query: "" });
        }}
        maxWidth="sm"
        fullWidth
        className="run_report_now_modal"
      >
        <DialogTitle className="keyword-dialog-header" style={{ textAlign: 'center' }}>
          Check Your AI Citation Report
        </DialogTitle>
        <DialogContent>
          <div className="ai-form-container" style={{ border: 'none', boxShadow: 'none', padding: '10px 0' }}>
            <div className="ai-form-group">
              <label className="ai-form-label">Web Page URL (Optional)</label>
              <input
                type="text"
                className="ai-form-input"
                placeholder="https://example.com/page"
                value={citationUrl}
                onChange={(e) => setCitationUrl(e.target.value)}
              />
              <div className="ai-form-hint">Must start with http:// or https://</div>
              {citationErrors.url && <div className="ai-form-error">{citationErrors.url}</div>}
            </div>
            <div className="ai-form-group">
              <label className="ai-form-label">
                Search Query <span style={{ color: '#ff601f' }}>*</span>
              </label>
              <input
                type="text"
                className="ai-form-input"
                placeholder="Enter the search prompt or question"
                value={citationQuery}
                onChange={(e) => setCitationQuery(e.target.value)}
              />
              {citationErrors.query && <div className="ai-form-error">{citationErrors.query}</div>}
            </div>
          </div>
        </DialogContent>
        <DialogActions className="dialog_box_btn" style={{ paddingBottom: '30px' }}>
          <button
            className="ai-submit-btn"
            onClick={async () => {
              let errs = { url: "", query: "" };
              let hasError = false;

              if (citationUrl && !/^(http|https):\/\//.test(citationUrl)) {
                errs.url = "URL must start with http:// or https://";
                hasError = true;
              }
              if (!citationQuery.trim()) {
                errs.query = "Query is mandatory";
                hasError = true;
              }
              if (hasError) {
                setCitationErrors(errs);
                return;
              }

              setLoading(true);
              try {
                const response = await axios.post(
                  `${process.env.REACT_APP_API_URL}technical/ai_citation_manual_run/`,
                  {
                    user_domain_id: esodata.domaindata.value.header_selected,
                    query: citationQuery,
                    url: citationUrl,
                  },
                  { headers: { Authorization: `${ApiToken}` } }
                );

                if (response.status === 200 || response.status === 201) {
                  toast.success(response.data?.message || "Report triggered successfully!");
                  setTimeout(() => { window.location.reload(); }, 1000);
                }

                setCitationFormOpen(false);
                setCitationUrl("");
                setCitationQuery("");
                setCitationErrors({ url: "", query: "" });
              } catch (err) {
                console.error(err);
                if (err?.response?.data?.error) {
                  toast.error(err.response.data.error);
                } else {
                  toast.error("Failed to trigger report");
                }
              } finally {
                setLoading(false);
              }
            }}
          >
            Generate Report
          </button>
          <button
            className="ai-reset-btn"
            onClick={() => {
              setCitationFormOpen(false);
              setCitationUrl("");
              setCitationQuery("");
              setCitationErrors({ url: "", query: "" });
            }}
          >
            Cancel
          </button>
        </DialogActions>
      </Dialog>

      {/* ── Mention Context Modal ───────────────────────────────────── */}
      <Dialog
        open={citedUrlModalOpen}
        onClose={handleCloseMentionModal}
        aria-labelledby="mention-context-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          id="mention-context-dialog-title"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "0.5px solid rgba(0,0,0,0.1)",
            paddingBottom: "12px",
          }}
        >
          <span style={{ fontSize: "15px", fontWeight: 500 }}>
            Mention Context
          </span>

          {selectedCitedUrls.length > 0 && (
            <span
              style={{
                fontSize: "11px",
                background: "#fff3ee",
                color: "#d85a30",
                border: "0.5px solid #f0997b",
                borderRadius: "20px",
                padding: "2px 10px",
                fontWeight: 500,
              }}
            >
              {selectedCitedUrls.length} context
              {selectedCitedUrls.length !== 1 ? "s" : ""}
            </span>
          )}
        </DialogTitle>

        {/* 👇 HEIGHT CONTROL HERE */}
        <DialogContent
          style={{
            padding: "16px 20px",
            maxHeight: "50vh",   // 🔥 reduce height
            overflowY: "auto",   // 🔥 enable scroll
          }}
        >
          {selectedCitedUrls.length > 0 ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                paddingTop: "8px",
              }}
            >
              {selectedCitedUrls.map((item, index) => (
                <div
                  key={index}
                  style={{
                    background: "#f9f9f9",
                    borderRadius: "8px",
                    border: "0.5px solid rgba(0,0,0,0.1)",
                    padding: "12px 14px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "11px",
                      fontWeight: 500,
                      color: "#888",
                      marginBottom: "6px",
                      textTransform: "uppercase",
                      letterSpacing: "0.4px",
                    }}
                  >
                    Context {index + 1}
                  </div>

                  <div
                    style={{
                      fontSize: "13px",
                      lineHeight: 1.7,
                      wordBreak: "break-word",
                      color: "#333",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: mdToHtml(item.text || ""),
                    }}
                  />
                </div>
              ))}
            </div>
          ) : (
            <p
              style={{
                color: "#888",
                fontSize: "13px",
                textAlign: "center",
                padding: "20px 0",
              }}
            >
              No context available.
            </p>
          )}
        </DialogContent>

        <DialogActions
          style={{
            padding: "12px 20px",
            borderTop: "0.5px solid rgba(0,0,0,0.1)",
          }}
        >
          <Button
            onClick={handleCloseMentionModal}
            style={{
              background: "none",
              border: "0.5px solid rgba(0,0,0,0.2)",
              borderRadius: "6px",
              padding: "6px 20px",
              fontSize: "13px",
              cursor: "pointer",
              color: "#333",
              textTransform: "none",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={modalIsOpen}
        onClose={closeModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter job_date_filter over_all_accessibility"
      >
        <DialogTitle className="keyword-dialog-header ">
          {"Filter By"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="cnt_hdr_blw_wrap row">
              <div>
                <div >
                  <div>
                    <span className="select_filter_text">Completed Date</span>
                    <Select
                      value={dEngineoption}
                      options={completedate}
                      placeholder="Select..."
                      labelField="completed_at"
                      valueField="id"
                      onChange={(values) => {
                        setSelectval(values);
                        SetdEngineoption(values);
                      }}
                      styles={customDropdownStyles()}
                      menuPortalTarget={document.body}
                    />
                  </div>
                </div>

                <div className="col">
                  <span className="text-error">{validation.dateerror}</span>
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <button
            className="form_submit_btn"
            style={{ cursor: "pointer" }}
          >
            Submit
          </button>
          <button style={{ cursor: "pointer" }} >
            close
          </button>
          <button
            className="form_submit_btn"
            style={{ cursor: "pointer" }}
            onClick={handleReset}
          >
            Reset
          </button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={modalIsOpen}
        onClose={closeModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter job_date_filter over_all_accessibility"
      >
        <DialogTitle className="keyword-dialog-header">{"Filter By"}</DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="cnt_hdr_blw_wrap">

              {/* AI MODEL */}
              <div style={{ marginBottom: "15px" }}>
                <span className="select_filter_text">AI Model</span>
                <Select
                  value={
                    [
                      { label: "OpenAI", value: "openai" },
                      { label: "Gemini", value: "gemini" },
                      { label: "Claude", value: "claude" },
                      { label: "Perplexity", value: "perplexity" },
                    ].find((o) => o.value === aimodel) || null
                  }
                  options={[
                    { label: "OpenAI", value: "openai" },
                    { label: "Gemini", value: "gemini" },
                    { label: "Claude", value: "claude" },
                    { label: "Perplexity", value: "perplexity" },
                  ]}
                  placeholder="Select AI Model"
                  onChange={(val) => {
                    setAimodel(val?.value || "");
                    setErrors((prev) => ({ ...prev, aimodel: "" })); // clear error on change
                  }}
                  styles={customDropdownStyles()}
                  menuPortalTarget={document.body}
                  isClearable
                />
                {errors.aimodel && (
                  <span style={{ color: "red", fontSize: "12px", marginTop: "4px", display: "block" }}>
                    {errors.aimodel}
                  </span>
                )}
              </div>

              {/* SENTIMENT */}
              <div style={{ marginBottom: "10px" }}>
                <span className="select_filter_text">Sentiment</span>
                <Select
                  value={
                    [
                      { label: "Positive", value: "positive" },
                      { label: "Negative", value: "negative" },
                      { label: "Neutral", value: "neutral" },
                    ].find((o) => o.value === sentiment) || null
                  }
                  options={[
                    { label: "Positive", value: "positive" },
                    { label: "Negative", value: "negative" },
                    { label: "Neutral", value: "neutral" },
                  ]}
                  placeholder="Select Sentiment"
                  onChange={(val) => {
                    setSentiment(val?.value || "");
                    setErrors((prev) => ({ ...prev, sentiment: "" })); // clear error on change
                  }}
                  styles={customDropdownStyles()}
                  menuPortalTarget={document.body}
                  isClearable
                />
                {errors.sentiment && (
                  <span style={{ color: "red", fontSize: "12px", marginTop: "4px", display: "block" }}>
                    {errors.sentiment}
                  </span>
                )}
              </div>

            </div>
          </DialogContentText>
        </DialogContent>

        <DialogActions className="dialog-action-button">

          {/* SUBMIT */}
          <button
            className="form_submit_btn"
            style={{ cursor: "pointer" }}
            onClick={() => {
              const newErrors = {};
              if (!aimodel) newErrors.aimodel = "Please select an AI Model.";
              if (!sentiment) newErrors.sentiment = "Please select a Sentiment.";

              if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
              }

              setErrors({});
              tableData();
              setIsOpen(false);
            }}
          >
            Submit
          </button>

          {/* CLOSE */}
          <button style={{ cursor: "pointer" }} onClick={closeModal}>
            Close
          </button>

          {/* RESET */}
          <button
            className="form_submit_btn"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setAimodel("");
              setSentiment("");
              setErrors({});
            }}
          >
            Reset
          </button>

        </DialogActions>
      </Dialog>
    </div>
  );
}
